import { PropsWithChildren } from 'react'
import cx from 'classnames'
import s from './styles.module.css'

interface CardListProps {
  type?: 'horizontal' | 'vertical'
  className?: string
}

export default function CardList({
  type = 'horizontal',
  className,
  children,
}: PropsWithChildren<CardListProps>) {
  if (type === 'vertical') {
    return <div className={className || s.verticalList}>{children}</div>
  }

  return (
    <div className={cx(s.horizontalScroll, className || s.horizontalDefault)}>
      {children}
    </div>
  )
}
